
import { loadStripe } from '@stripe/stripe-js/pure' // the pure import stops Stripe.js loading on every page on our site
import DonatePage from './Pages/DonatePage';
import MonthlyUpsellPage from './Pages/MonthlyUpsellPage';
import CheckoutPage from './Pages/CheckoutPage';

export default function DonateForm({ action, onSubmit, isPreview = true }) {
  const { config } = action
  const [presetAmounts, setPresetAmounts] = useState(config.amounts || [])
  const [initialAmount, setInitialAmount] = useState(parseFloat(config.defaultAmount) || 0)
  const fundraisingFees = useSel(s => (s.builder || s.taker).flow.fundraisingFees)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)

    const amountParam = urlParams.get('amount')
    if (amountParam && !isNaN(parseFloat(amountParam))) {
      setInitialAmount((parseFloat(amountParam) * 100))
    }

    const amountsParams = urlParams.getAll('amounts[]')
    if (amountsParams && amountsParams.length > 0) {
      const parsedAmounts = amountsParams
        .map(amount => parseFloat(amount) * 100)
        .filter(amount => !isNaN(amount))

      if (parsedAmounts.length > 0) {
        setPresetAmounts(parsedAmounts)
      }
    }
  }, [])

  const [amount, setAmount] = useState(initialAmount);

  useEffect(() => {
    setAmount(initialAmount)
  }, [initialAmount])

  const [showCheckout, setShowCheckout] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const [page, setPage] = useState('donate');
  const [coverFee, setCoverFee] = useState(false);

  useEffect(() => {
    if (config.coverFee && config.preTickCoverFee) {
      setCoverFee(true);
    }
  }, [config.coverFee, config.preTickCoverFee]);

  const { paymentAmount, coverFeeAmount } = useMemo(() => {
    const coverFeeAmount = Math.round(
      (amount + fundraisingFees.fixed) / (1 - (fundraisingFees.rate)) - amount
    );

    if (coverFee) {
      return { paymentAmount: amount + coverFeeAmount, coverFeeAmount }
    } else {
      return { paymentAmount: amount, coverFeeAmount }
    }
  }, [amount, coverFee]);


  const stripePromise = useMemo(() => loadStripe(window.ENV.STRIPE_PUBLIC_KEY, { stripeAccount: window.ENV.STRIPE_ACCOUNT_ID }), [])

  function handleSubmit() {
    if (page === 'donate' && !isMonthly && config.enableMonthlyDonations && config.enableMonthlyUpsell) {
      setPage('upsell');
    } else {
      handleStartCheckout();
    }
  }

  function handleStartCheckout() {
    if (!isPreview) {
      setShowCheckout(true);
    } else {
      // In preview mode, just show what would happen
      console.log('Preview mode - would donate:', amount, isMonthly ? 'monthly' : 'one-off');
    }
  }

  return (
    <div className="donation-form">
      {!showCheckout && page === 'donate' && (
        <DonatePage
          config={config}
          isMonthly={isMonthly}
          setIsMonthly={setIsMonthly}
          amount={amount}
          setAmount={setAmount}
          coverFee={coverFee}
          setCoverFee={setCoverFee}
          coverFeeAmount={coverFeeAmount}
          paymentAmount={paymentAmount}
          handleSubmit={handleSubmit}
          presetAmounts={presetAmounts}
          stripePromise={stripePromise}
          onComplete={onSubmit}
        />
      )}

      {!showCheckout && page === 'upsell' && (
        <MonthlyUpsellPage
          config={config}
          amount={paymentAmount}
          setMonthly={setIsMonthly}
          handleSubmit={handleSubmit}
          coverFee={coverFee}
          setCoverFee={setCoverFee}
          coverFeeAmount={coverFeeAmount}
          handleBack={() => setPage('donate')}
          handleSubmit={handleSubmit}
        />
      )}

      {showCheckout && (
        <CheckoutPage
          amountInMinorUnits={amount}
          isMonthly={isMonthly}
          coverFee={coverFee}
          onComplete={onSubmit}
          stripePromise={stripePromise}
        />
      )}
    </div>
  );
}

